const readFileAsBuffer = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      resolve(reader.result);
    });
    reader.readAsArrayBuffer(file);
  });
};

export default readFileAsBuffer;
